/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */

import { UiService } from '@services/ui/ui.service';
import { WizardService } from '@services/wizard/wizard.service';
import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { from, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WizardNavigationService } from '@services/wizard-navigation/wizard-navigation.service';

@Injectable({
  providedIn: 'root'
})
export class StepResolverService implements Resolve<boolean> {
  constructor(
    private uiService: UiService,
    private wizardService: WizardService,
    private wizardNav: WizardNavigationService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.activateStep();
  }

  /**
   * attiva lo step
   */
  private activateStep(): Observable<boolean> {
    if (!this.wizardNav.areNextNavPropsDefined()) {
      return this.navigateAway();
    }

    return this.wizardService
      .loadActiveStep(
        this.wizardNav.nextNavProps.stepCode,
        this.wizardNav.nextNavProps.params
      )
      .pipe(catchError(err => this.navigateAway(err)));
  }

  /**
   * naviga via dalla pagina dello step
   */
  private navigateAway(err?: any): Observable<boolean> {
    if (!!err && typeof err === 'string') {
      this.uiService.showWarningToast(err);
    }

    return from(this.wizardNav.navigateToStart()).pipe(map(() => false));
  }
}
